$(function () {

    $(document).on('change keyup', '#textboxGiftCardPriceX', function () {
        valueSelected();
    });
    $(document).on('change', '#dropdownGiftCardPriceX', function () {
        valueSelected();
    });

    $(document).on('click', '[data-single-giftcard]', function () {
        productSelected();
    });

    $(document).on('product-selected', function () {
        productSelected();
    });

    var valueSelected = function () {

        if (!$('#product-select-container').is(':visible')) {
            $('#product-select-container').slideDown(function () {
                for (var i = 0; i < window.glides.length; i++) {
                    window.glides[i].update(window.options.glideOptions);
                    var event;
                    if (typeof (Event) === 'function') {
                        event = new Event('resize');
                    } else {
                        event = document.createEvent('Event');
                        event.initEvent('resize', true, true);
                    }

                    window.dispatchEvent(event);
                }
            });
        }

        var autoOpen = $('[data-auto-open]').data('auto-open');
        if (autoOpen) {
            productSelected();
        }
    };

    var productSelected = function () {
        $("#gift-delivery").slideDown();
        $("#proceed-to-payment").slideDown();
    };
});
